module.exports = __webpack_public_path__ + "img/12.b20a539b.svg";